export default function Section2() {
    const services = [
      "Logo",
      "Business Cards & Stationary",
      "Social Media Posts",
      "Website Banners and Sliders",
      "Packaging",
      "T-Shirt Designs",
      "Book Covers",
      "Company Profile",
    ];
  
    return (
      <div className="Section2 py-[35px] bg-[#F5F5F5]">
        <div className="container-1280 section2-container flex flex-col xl:flex-row w-full relative px-[15px] mx-auto md:w-[750px] lg:w-[970px] xl:w-[100%] group mb-[20px]">
          {/* Circle with Icon */}
          <div className="relative flex md:flex-col justify-center  xl:items-center">
            <div className="w-[75px] h-[80px] rounded-[50%] group-hover:shadow-[inset_0_0_0_44px_#cd2122] shadow-[inset_0_0_0_2px_#cd2122] relative transition-all ease-in-out duration-300">
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-kl text-[22px] text-[#cd2122] transition-all ease-in-out duration-300 group-hover:text-white">
                <span className="text-[#cd2122] group-hover:text-white"></span>
              </div>
            </div>
  
            {/* Vertical Line */}
            <div className="h-full hidden xl:block w-[1px] bg-[rgba(0,0,0,.07)]"></div>
          </div>
  
          {/* Text Content */}
          <div className="text-[#535353] text-center md:text-left xl:ml-5 font-open">
            <h2 className="text-[24px] leading-[32px] md:text-[34px] font-mont font-bold text-[#DA2128] md:leading-[40px] my-[0.67em]">
              Services We Provide
            </h2>
  
            <p className="text-[18px] mb-5">
              You can choose our Graphic Designing services from a wide range of
              areas, tailoring to your specific needs. We communicate
              professionally and creatively through high-resolution graphics. This
              team consists of designing:
            </p>
  
            <ul>
              {services.map((service, index) => (
                <li
                  key={index}
                  className="relative text-[18px] mb-5 text-left pl-5 xl:pl-0  before:absolute before:block xl:before:block before:rounded-[50%] before:-left-[0] xl:before:-left-[63px] before:top-[8px] before:shadow-[0_0_0_2px_#cd2122] before:w-[6px] before:h-[6px] before:bg-[#fff] hover:before:shadow-[0_0_0_3px_#cd2122] before:transition-all before:ease-in-out before:duration-[.15s]"
                >
                  {service}
                </li>
              ))}
            </ul>
            
          </div>
          
        </div>
        <p class="container-1280 text-[16px] font-open text-[#373737] w-[90%] md:w-[80%] mx-auto">
        Each service helps boost your brand’s identity. It also improves user experience and supports
your marketing goals. We make sure your logo and website design work together. This creates
a strong brand experience that communicates clearly with your customers.
      </p>
      <h2 class="container-1280 text-3xl font-bold mb-4 mt-4 text-[#DA2128] w-[90%] md:w-[80%] mx-auto">Professional Graphic Design and Branding Services in Dubai</h2>
      <p class="container-1280 text-[16px] font-open text-[#373737] mb-6 w-[90%] md:w-[80%] mx-auto">
        We’re a trusted graphic designing company in Dubai offering a full range of graphic
design and branding services. Our goal is to help brands create a strong and lasting
presence, whether you're launching a new product or rebranding an existing business. We rank
among the best graphic design companies in Dubai. Our strengths are attention to detail,
speedy delivery, and a team-focused approach. Companies across the nation choose us for
their graphic design needs. They rely on us for consistent, high-quality results every time.
      </p>
      <h2 class="container-1280 text-3xl font-bold mb-4 text-[#DA2128] w-[90%] md:w-[80%] mx-auto">Why Choose Mean3 as Your Graphic Design Agency</h2>
      <p class="container-1280 text-[16px] font-open text-[#373737] mb-6 w-[90%] md:w-[80%] mx-auto">
        We are a graphic design agency that provides full services. We mix creativity and business
insight to create designs that deliver real results. As a graphic design marketing agency, we do
more than just create visuals. We know how design affects conversions, user behavior, and
brand perception. We are dedicated to providing graphic design services in Dubai. Our goal
is to help your brand thrive in competitive markets. If you need the best graphic designing
companies in Dubai, look no further than Mean3. They focus on creativity, consistency, and
reliability. You can always count on their team.
      </p>
      </div>
      
    );
  }
  